import liquidEngine from 'FlowBuilder/components/ActionViews/liquidEngine'
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate'

export default function SignatureCount({ actionId }) {
    const flow = useSel(s => s.taker?.flow || s.builder?.flow || {})
    const petitionCount = flow.flowFields?.petition_count || 0
    const petitionTarget = flow.flowFields?.petition_target || 0
    const width = petitionTarget ? Math.min(100, Math.max(0, (petitionCount / petitionTarget) * 100)) : 0
    

    const { fallback: {
        signatureCountText: signatureCountTextRaw,
    }, language } = useActionTranslate({ actionId });

    const petitionCountLocalised = Number(petitionCount).toLocaleString(language || 'en');
    const petitionTargetLocalised = Number(petitionTarget).toLocaleString(language || 'en');

    const signatureCountText = useMemo(() => liquidEngine.parseAndRenderSync(signatureCountTextRaw, { petitionTarget: petitionTargetLocalised }), [signatureCountTextRaw, petitionTargetLocalised]);

    return <>
        <div className="mvmt-progress-container progress">
            <div className="mvmt-progress-bar progress-bar"
                style={{ width: `${width}%` }}>
            </div>
        </div>

        <p id="rsvp-count">
            <strong>{ petitionCountLocalised }</strong><span> { signatureCountText }</span>
        </p>
    </>
}
